import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("input", {
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterCity && _ctx.filterCity(...args))),
      class: "form-control",
      type: "text",
      id: "searchCity",
      name: "searchCity",
      placeholder: "Search city"
    }, null, 32)
  ], 32))
}